import { isRestrictable } from './restrictionTypeguards';
export var ItemType;
(function (ItemType) {
    ItemType["MenuItem"] = "menuItem";
    ItemType["SequencedFlow"] = "sequencedFlow";
    ItemType["NonSequencedFlow"] = "nonSequencedFlow";
    ItemType["Quiz"] = "quiz";
    ItemType["ResourcesFolder"] = "resourcesFolder";
    // Content items
    ItemType["Question"] = "note";
    ItemType["Split"] = "split";
    ItemType["Section"] = "section";
    ItemType["StartingMessage"] = "startingMessage";
    ItemType["Hotspot"] = "hotspot";
    ItemType["BlindMapQuestion"] = "blindMapQuestion";
    ItemType["SequencedFlowStep"] = "sequencedFlowStep";
    ItemType["Resource"] = "resource";
    ItemType["HotspotTab"] = "hotspotTab";
    ItemType["Answer"] = "answer";
})(ItemType || (ItemType = {}));
export var RestrictionType;
(function (RestrictionType) {
    RestrictionType["none"] = "none";
    RestrictionType["customTime"] = "customTime";
    RestrictionType["audioDuration"] = "audioDuration";
})(RestrictionType || (RestrictionType = {}));
export const DefaultRestriction = {
    restrictionType: RestrictionType.none,
};
export function createCustomTimeRestriction(duration, autoProgress) {
    if (autoProgress !== undefined) {
        return {
            restrictionType: RestrictionType.customTime,
            duration,
            autoProgress,
        };
    }
    return {
        restrictionType: RestrictionType.customTime,
        duration,
    };
}
export function createAudioRestriction(autoProgress) {
    if (autoProgress !== undefined) {
        return {
            restrictionType: RestrictionType.audioDuration,
            autoProgress,
        };
    }
    return {
        restrictionType: RestrictionType.audioDuration,
    };
}
export const setAutoProgress = (restriction, autoProgress) => {
    return {
        ...restriction,
        autoProgress: autoProgress,
    };
};
/** Returns true if given item has a precondition that has to be lifted before student can navigate further in a course. */
export const hasNavigationRestriction = (item) => item.restriction.restrictionType !== RestrictionType.none;
export function hasAudioRestriction(item) {
    return isRestrictable(item) && item.restriction.restrictionType === RestrictionType.audioDuration;
}
export var ModalSize;
(function (ModalSize) {
    ModalSize["Fullscreen"] = "Fullscreen";
    ModalSize["Small"] = "Small";
    ModalSize["Sidebar"] = "Sidebar";
})(ModalSize || (ModalSize = {}));
